import { render, staticRenderFns } from "./ReportSessionDetail.vue?vue&type=template&id=06d01a16"
import script from "./ReportSessionDetail.vue?vue&type=script&lang=js"
export * from "./ReportSessionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports